import { render, staticRenderFns } from "./HighlightsPage.vue?vue&type=template&id=0180eeca&"
import script from "./HighlightsPage.vue?vue&type=script&lang=js&"
export * from "./HighlightsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports